import React from 'react';

import {Box, Typography, useTheme} from '@mui/material';

import Icons from 'assets/icons';

const styles = {
    playerShirt: {
        overflow: 'hidden',
        position: 'relative',
        // filter: 'drop-shadow(0 6px 12px rgba(0,0,0,0.4))',
        cursor: 'grab',
        '&:hover': {
            transform: 'scale(1.03)',
        },
        '&:active': {
            transform: 'scale(1.07)',
            cursor: 'grabbing',
        },
        '& span': {
            textAlign: 'center',
            position: 'absolute',
            top: 10,
            left: 0,
            width: '100%',
            fontWeight: '700',
            // textShadow: '2px 2px 4px rgba(0,0,0,0.6), 0 0 10px rgba(255,255,255,0.2)',
        },
    },
    playerDisabled: (theme) => ({
        opacity: theme.palette.lineup.playerDisabled,
        filter: 'grayscale(0.6) blur(0.5px)',
        overflow: 'hidden',
    })
};

const PlayerShirt = ({number, colors, disabled}) => {
    const theme = useTheme();
    const svgStyle = {
        width: 60,
        height: 60,
        fill: colors.value1,
        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
        transition: 'scale 0.3s ease',
    };

    return (
        <Box sx={{...styles.playerShirt, ...(disabled && styles.playerDisabled(theme))}}>
            <Icons.Shirt style={svgStyle}>{number}</Icons.Shirt>
            <Typography
                component="span"
                variant="h2"
                sx={{
                    color: `${colors.textColor}!important`,
                }}>
                {number}
            </Typography>
        </Box>
    );
};

export default PlayerShirt;
